import { ICapsuleFile, ICapsuleFolder } from "../../typings/board/Models";

export const CAPSULE_FILE : string = "CapsuleFile";
export const CAPSULE_FOLDER : string = "CapsuleFolder";

export class CapsuleFolder implements ICapsuleFolder {
    public relativePath: string;
    public name: string;
    public size: number;
    public modifiedDate: string;
    public files: ICapsuleFile[];
    public subFolders: ICapsuleFolder[];

    constructor(name : string, relativePath: string) {
        this.name = name;
        this.relativePath = relativePath;
        this.size = 0;
        this.modifiedDate = null;
        this.files = [];
        this.subFolders = [];
    }
}

export class CapsuleFile implements ICapsuleFile {
    public fullName: string;
    public name: string;
    public extension: string;
    public size: number;
    public modifiedDate: string;

    constructor(filename: string, extension:string) {
        this.name = filename;
        this.extension = extension;
        this.size = 0;
        this.modifiedDate = null;
    }
}


// WEBPACK FOOTER //
// ./app/capsule/capsuleFolder.ts